/**
 * @author Ivan Toth.
 * gpp - autocheck tlogs table
 */
var DetailGppAcController = (function () {
    function DetailGppAcController(topic) {
        this.topic = topic;
        this.visible = false;
    }
    ;
    DetailGppAcController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    DetailGppAcController.$inject = ['topic'];
    return DetailGppAcController;
}());
var DetailGppAcComponent = (function () {
    function DetailGppAcComponent() {
        this.templateUrl = 'detail-validation-gpp-ac.html';
        this.controllerAs = 'vm';
        this.controller = DetailGppAcController;
    }
    return DetailGppAcComponent;
}());
angular
    .module('application')
    .component('detailGppAc', new DetailGppAcComponent());

//# sourceMappingURL=detail.validation.decision.component.js.map
